export const INVENTORY_TYPE_TARGETING = {
    ALL: 'ALL',
    WEB: 'WEB',
    APP: 'APP',
};
